import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Zap, LogOut } from 'lucide-react';

interface DashboardLayoutProps {
  children: React.ReactNode;
  activeTab?: 'market-research' | 'ai-content';
  onTabChange?: (tab: 'market-research' | 'ai-content') => void;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Top Header Bar */}
      <header className="bg-brand-navy border-b border-brand-navy/80 sticky top-0 z-50">
        <div className="px-6 py-4 flex justify-between items-center">
          {/* Left: Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-brand-primary flex items-center justify-center">
              <Zap className="h-6 w-6 text-white" />
            </div>
            <span className="font-bold text-white text-2xl">Product Builder</span>
          </div>
          
          {/* Right: Bright.Studio + Sign Out */}
          <div className="flex items-center gap-4">
            <span className="font-bold text-white text-xl">Bright.Studio</span>
            <Button
              variant="ghost"
              size="sm"
              className="text-white/70 hover:text-white hover:bg-white/10"
              onClick={() => navigate('/')}
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sign Out
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="bg-slate-50 min-h-[calc(100vh-72px)]">
        <div className="container mx-auto px-6 py-3 max-w-full">{children}</div>
      </main>
    </div>
  );
}
